import { BrowserRouter, Routes, Route } from "react-router-dom";
import BlogArchive from "./pages/BlogArchive";
import SinglePost from "./pages/SinglePost";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      {/* Navbar can stay here */}
      <Routes>
        <Route path="/" element={<BlogArchive />} />
        <Route path="/post/:slug" element={<SinglePost />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
